import axios from 'axios'
import { useState } from "react"
import { BsEye } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import CardLoader from 'src/components/orgainsms/CardProduct/CardLoader'
import useSwr from 'swr'

const fether = async url => {
  const response = await axios(url)
  return response.data
}

const MainGallery = () => {
  const navigate = useNavigate()
  const API = process.env.REACT_APP_API
  const { data, isLoading } = useSwr(API + '/gallery', fether)

  const handleDetail = data => {
    navigate(`/gallery/${data.id}`, {
      state: data
    })
  }

  const [clients] = useState([
    6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27
  ])

  return (
    <>
      <div className="relative h-[42vh] sm:h-[50vh] md:h-[65vh] overflow-hidden">
        <img
          className="w-full h-full object-cover"
          src="/images/p3.png"
          alt="Gallery Hero"
        />

        <div className="absolute inset-0 flex flex-col text-white">
          <div className="flex-1 flex flex-col justify-center items-center px-4 text-center">
            <h1 className="text-[26px] sm:text-[32px] md:text-5xl font-semibold leading-tight">
              Mewujudkan Visi Anda Bersama Kami
            </h1>
            <h2 className="mt-3 text-[16px] sm:text-[18px] md:text-2xl">
              Portofolio Project Kami
            </h2>
          </div>

          <div className="h-14 sm:h-16 md:h-20 flex items-center justify-center px-4">
            <p className="text-[10px] sm:text-[12px] md:text-[16px] text-center tracking-wide">
              PROFESIONAL DISPLAY • COLLABORATION SYSTEM • MAINTENANCE • INSTALLATION
            </p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden bg-gray-50 py-6">
        <div className="animate-marquee flex items-center gap-8 sm:gap-12">
          {clients.map((n) => (
            <img
              key={`a-${n}`}
              src={`/images/clients/${n}.png`}
              alt={`Client ${n}`}
              className="h-8 sm:h-10 md:h-12 object-contain"
              loading="lazy"
              onError={(e) => { e.currentTarget.style.display = 'none' }}
            />
          ))}

          {clients.map((n) => (
            <img
              key={`b-${n}`}
              src={`/images/clients/${n}.png`}
              alt=""
              className="h-8 sm:h-10 md:h-12 object-contain"
              loading="lazy"
              aria-hidden
              onError={(e) => { e.currentTarget.style.display = 'none' }}
            />
          ))}
        </div>
      </div>

      <div className="px-4 sm:px-6 lg:px-14 py-10 sm:py-14">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
          {isLoading && <CardLoader />}

          {data?.map(item => (
            <GalleryItem
              key={item.id}
              title={item.title}
              year={item.tgl}
              image={item.image}
              onClick={() => handleDetail(item)}
            />
          ))}
        </div>
      </div>
    </>
  )
}

const GalleryItem = ({ title, year, onClick, image }) => {
  const thumb =
    image?.length > 0
      ? `${process.env.REACT_APP_IMAGE}/${image[0].image}`
      : "/images/gallery/1.png"

  return (
    <button
      onClick={onClick}
      className="
        group block text-left rounded-xl
        border border-gray-200/70 bg-white
        shadow-sm hover:shadow-lg transition-shadow
        touch-manipulation active:scale-[0.98]
        focus:outline-none focus-visible:ring-2
        focus-visible:ring-emerald-500 focus-visible:ring-offset-2
      "
    >
      <div className="relative h-[180px] sm:h-[200px] md:h-[220px] lg:h-[260px] overflow-hidden">
        <div className="
          absolute inset-3 flex items-end justify-end
          opacity-0 group-hover:opacity-100
          transition-opacity duration-300 z-10 pointer-events-none
        ">
          <div className="h-9 w-9 bg-white/95 rounded-full flex items-center justify-center shadow">
            <BsEye className="text-xl text-[#2E7462]" />
          </div>
        </div>

        <img
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          src={thumb}
          alt={title || "gallery"}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null
            e.currentTarget.src = "/images/gallery/1.png"
          }}
        />

        <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-200/80" />
      </div>

      <div className="p-4 transition-colors duration-300 group-hover:bg-[#006c63]">
        <h3 className="text-[#006c63] group-hover:text-white text-[16px] sm:text-[18px] md:text-[20px] font-medium line-clamp-2">
          {title}
        </h3>
        <span className="block mt-1 text-gray-500 text-[12px] group-hover:text-white/90">
          {year}
        </span>
      </div>
    </button>
  )
}

export default MainGallery
